"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgSearch(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M10.105 0c5.581 0 10.106 4.524 10.106 10.105 0 2.518-.922 4.821-2.445 6.59l6.012 6.011a.758.758 0 01-1.072 1.072l-6.01-6.012a10.066 10.066 0 01-6.59 2.445C4.523 20.21 0 15.686 0 10.105 0 4.525 4.524 0 10.105 0zm0 1.516a8.59 8.59 0 100 17.179 8.59 8.59 0 000-17.18z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgSearch;
exports.default = _default;